module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="modal fade" id="assignmentModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">\n  <div class="modal-dialog">\n    <div class="modal-content">\n      <div class="modal-header">\n        ' +
((__t = (terms.selectAssignment[language])) == null ? '' : __t) +
' <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button> &nbsp\n      </div>\n      <div class="modal-body">\n        <div id="assignments"></div>\n      </div>\n\n    </div>\n  </div>\n</div>';

}
return __p
}